<template>
  <svg
    class="popup-sign"
    width="60"
    height="61"
    viewBox="0 0 60 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.0488281" width="60" height="60" rx="30" fill="#27BC00" />
    <path
      d="M17 31.0488L25 40.0488L43 20.0488"
      stroke="white"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
